import { MixedUserChoice } from './MixedUserChoice';
import { IRecipientList, toRecipients } from './RecipientList';

export function remapMailRecipients(mail: { recipients: IRecipientList, recipientList?: any }, choices: MixedUserChoice[]) {
    const addresses = mail?.recipients?.emailAddresses;
    mail.recipientList = undefined;
    if (choices) {
        mail.recipients = toRecipients(choices);
    }
    if (addresses && mail.recipients) {
        mail.recipients.emailAddresses = addresses;
    }
    return mail;
}